// Dialog modal ขนาดเล็ก — framework-free, ใช้คลาสจาก components.css
export interface DialogAction {
  label: string;
  kind?: "primary" | "outline" | "ghost" | "subtle";
  onClick?: () => void;
  close?: boolean; // default true — กดแล้วปิด dialog
}

export interface DialogOptions {
  title: string;
  subtitle?: string;
  body: string | HTMLElement; // HTML string หรือ element
  actions?: DialogAction[];
  onClose?: () => void;
}

const ICON_CLOSE =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

export function openDialog(opts: DialogOptions): () => void {
  const prevFocus = document.activeElement as HTMLElement | null;

  const overlay = document.createElement("div");
  overlay.className = "dialog-overlay";
  overlay.innerHTML = `
    <div class="dialog" role="dialog" aria-modal="true" aria-label="${escapeHtml(opts.title)}">
      <div class="dialog-header">
        <div>
          <h2 class="dialog-title">${escapeHtml(opts.title)}</h2>
          ${opts.subtitle ? `<p class="dialog-subtitle">${escapeHtml(opts.subtitle)}</p>` : ""}
        </div>
        <button type="button" class="btn btn-ghost btn-icon btn-sm dialog-close" aria-label="ปิดหน้าต่าง">${ICON_CLOSE}</button>
      </div>
      <div class="dialog-body"></div>
    </div>
  `;

  const bodyEl = overlay.querySelector<HTMLElement>(".dialog-body")!;
  if (typeof opts.body === "string") bodyEl.innerHTML = opts.body;
  else bodyEl.appendChild(opts.body);

  if (opts.actions?.length) {
    const footer = document.createElement("div");
    footer.className = "dialog-footer";
    for (const a of opts.actions) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = `btn btn-${a.kind ?? "outline"}`;
      btn.textContent = a.label;
      btn.addEventListener("click", () => {
        a.onClick?.();
        if (a.close !== false) close();
      });
      footer.appendChild(btn);
    }
    overlay.querySelector(".dialog")!.appendChild(footer);
  }

  let closed = false;
  function close() {
    if (closed) return;
    closed = true;
    overlay.classList.remove("open");
    document.removeEventListener("keydown", onKey);
    window.setTimeout(() => {
      overlay.remove();
      opts.onClose?.();
      prevFocus?.focus?.();
    }, 220);
  }

  function onKey(e: KeyboardEvent) {
    if (e.key === "Escape") {
      e.stopPropagation();
      close();
    }
  }

  overlay.addEventListener("mousedown", (e) => {
    if (e.target === overlay) close();
  });
  overlay.querySelector(".dialog-close")!.addEventListener("click", close);
  document.addEventListener("keydown", onKey);

  document.body.appendChild(overlay);
  requestAnimationFrame(() => {
    overlay.classList.add("open");
    overlay.querySelector<HTMLElement>(".dialog-close")!.focus();
  });

  return close;
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
}
